import React, { PureComponent } from 'react'
import { DsTypography } from '@am92/react-design-system'

export default class NotFoundPage extends PureComponent {
  render() {
    return <DsTypography variant='headingBoldExtraLarge'>Page 404</DsTypography>
  }
}
